<template>
  <div>
    <span class="font-bold text-lg">To'lovlar ro'yxati</span>

    <!-- Desktop Table View (hidden on mobile) -->
    <div
      class="hidden md:block max-h-[calc(100vh-250px)] overflow-y-auto overflow-x-auto"
    >
      <table class="min-w-full w-full border-collapse">
        <thead>
          <tr>
            <th class="sticky top-0 bg-white z-10 px-4 py-2 border-b">№</th>
            <th class="sticky top-0 bg-white z-10 px-4 py-2 border-b text-left">
              To'lov cheki
            </th>
            <!--            <th-->
            <!--              class="sticky top-0 bg-white z-10 px-4 py-2 border-b text-center"-->
            <!--            >-->
            <!--              Izox-->
            <!--            </th>-->
            <th class="sticky top-0 bg-white z-10 px-4 py-2 border-b">
              Holati
            </th>
            <th class="sticky top-0 bg-white z-10 px-4 py-2 border-b">
              Sanasi
            </th>
            <th class="sticky top-0 bg-white z-10 px-4 py-2 border-b">Narxi</th>
            <th
              class="sticky top-0 bg-white z-10 px-4 py-2 border-b text-center"
              v-if="checkPermission([110])"
            >
              Amallar
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in vidioData" :key="index">
            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">
              {{ index + 1 }}
            </td>
            <td
              class="px-4 py-2 border-b border-gray-200 text-sm cursor-pointer"
            >
              <div class="flex items-center">
                <div class="relative mr-3 flex-shrink-0">
                  <img
                    :src="item.paymentPhoto"
                    class="w-28 h-20 object-cover rounded-md"
                    alt="PaymentPhoto"
                  />
                </div>
                <div class="relative group">
                  <p class="text-sm truncate max-w-xs">{{ item.title }}</p>
                  <div
                    class="hidden group-hover:block absolute z-10 bg-gray-800 text-white p-2 rounded shadow-lg text-xs w-60 mt-1"
                  >
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </td>
            <!--            <td class="px-4 py-2 border-b border-gray-200 text-sm text-left">-->
            <!--              <div class="relative group">-->
            <!--                <p class="text-sm truncate max-w-xs">{{ item.description }}</p>-->
            <!--                <div-->
            <!--                  class="hidden group-hover:block absolute z-10 bg-gray-800 text-white p-2 rounded shadow-lg text-xs w-60 mt-1"-->
            <!--                >-->
            <!--                  {{ item.description }}-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </td>-->
            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">
              <span v-if="item.status === 'PAID'"> To'langan </span>
              <div
                v-if="item.status === 'REJECTED'"
                class="flex items-center justify-center gap-0.5"
              >
                <span class="font-bold" style="color: #ff2d55">
                  Rad etilgan
                </span>
                <el-tooltip :content="item.rejectReason" placement="top">
                  <img
                    src="@/assets/image/reject_icon.png"
                    alt="reject"
                    class="cursor-pointer"
                  />
                </el-tooltip>
              </div>
              <span
                v-if="item.status === 'ACCEPTED'"
                class="text-green-500 font-bold"
              >
                Tasdiqlangan
              </span>
            </td>
            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">
              {{ item.date }}
            </td>
            <!--            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">-->
            <!--              {{ item.view }}-->
            <!--            </td>-->
            <!--            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">-->
            <!--              {{ item.comment }}-->
            <!--            </td>-->
            <!--            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">-->
            <!--              {{ item.like }}-->
            <!--            </td>-->
            <!--            </td>-->

            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">
              {{ item.price }} so'm
            </td>
            <!--            <td class="px-4 py-2 border-b border-gray-200 text-sm text-center">-->
            <!--              {{ item.purchases }}-->
            <!--            </td>-->
            <td
              class="px-4 py-2 border-b border-gray-200 text-sm text-center"
              v-if="checkPermission([110])"
            >
              <!--              <span-->
              <!--                class="text-green-600 bg-[#afffaf] rounded-[14px] px-[8px] py-[2px] cursor-pointer"-->
              <!--                @click="confirmApproval(item)"-->
              <!--                >Tasdiqlash</span-->
              <!--              >-->
              <div class="flex gap-1 justify-center">
                <button
                  class="py-[5px] px-[10px] bg-green-500 text-white rounded-[5px] border-none"
                  @click="confirmApproval(item)"
                  v-if="item.status === 'PAID'"
                >
                  <i class="fa-solid fa-check"></i>
                </button>
                <button
                  class="py-[5px] px-[10px] bg-red-500 text-white rounded-[5px] border-none"
                  @click="canselApproval(item)"
                  v-if="item.status === 'PAID'"
                >
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      v-if="isSubmitting"
      class="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center"
    >
      <div class="flex flex-col items-center">
        <svg
          class="animate-spin h-8 w-8 text-indigo-600 mb-2"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          ></path>
        </svg>
        <p class="text-blue-500 text-sm">Yuklanmoqda...</p>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/http";
import { ElMessageBox, ElMessage } from "element-plus";

export default {
  data() {
    return {
      vidioData: [
        // {
        //   id: "7330dcf8-24ca-4e1e-84a2-3664d697ddd8",
        //   videoId: "c6845262-d6f9-4359-8c04-88841328d1b3",
        //   orgId: "28b75a0f-c9b3-43f4-a4f6-ec37d7d3a5e8",
        //   title: "FrontedPractice",
        //   description: "FrontedPractice darslari",
        //   price: 23000,
        //   paymentPhoto:
        //     "https://snappy.uz/files/videos/2025-05/28b75a0f-c9b3-43f4-a4f6-ec37d7d3a5e8/79c0c2f6-a8a9-4acd-a35a-5777e19ceb62.jpg",
        //   date: "11.05.2025",
        //   status: "PAID",
        // },
      ],
      isSubmitting: false,
    };
  },
  mounted() {
    this.getVidioList();
  },
  methods: {
    canselApproval(item) {
      ElMessageBox.prompt("Bekor qilish sababini kiriting:", "Bekor qilish", {
        confirmButtonText: "Yuborish",
        cancelButtonText: "Bekor qilish",
        inputPlaceholder: "Masalan: noto‘g‘ri yuklangan video",
        inputValidator: (value) => {
          if (!value) {
            return "Sababni kiritish majburiy";
          }
          return true;
        },
        center: true,
      })
        .then(async ({ value }) => {
          try {
            let response = await http.post(
              `/payment/payment-action?paymentId=${item.id}&type=reject`,
              {
                rejectReason: value,
              }
            );
            if (response) {
              ElMessage({
                type: "success",
                message: "Bekor qilindi!",
              });
              window.location.reload();
            }
          } catch (error) {
            console.error("Xatolik:", error);
          }
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "Amal bekor qilindi",
          });
        });
    },
    confirmApproval(item) {
      ElMessageBox.confirm("Bu videoni tasdiqlashni hohlaysizmi ?", {
        confirmButtonText: "Ha",
        cancelButtonText: "Yo‘q",
        center: true,
        draggable: false,
      })
        .then(async () => {
          try {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            let response = await http.post(
              `/payment/payment-action?paymentId=${item.id}&type=accept`
            );
            if (response) {
              ElMessage({
                type: "success",
                message: "Tasdiqlandi!",
              });
              window.location.reload();
            }
          } catch (error) {
            console.error("failed", error);
          } finally {
            this.isSubmitting = false;
          }
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "Bekor qilindi",
          });
        });
    },
    async getVidioList() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        const userInfo = JSON.parse(localStorage.getItem("user_info"));
        let url = "/payment/payment-list";
        if (userInfo && userInfo.orgId !== null) {
          url = `/payment/payment-list?orgId=${userInfo.orgId}`;
        }
        let response = await http.post(url, {});
        this.vidioData = response.data.data.content;
      } catch (error) {
        console.error("failed", error);
      } finally {
        this.isSubmitting = false;
      }
    },
    checkPermission(allowedPermissions) {
      const userInfo = JSON.parse(localStorage.getItem("user_info"));
      const userPermissions = userInfo ? userInfo.permissionId : [];
      return allowedPermissions.some((permission) =>
        userPermissions.includes(permission)
      );
    },
  },
};
</script>
